import { Component, input, OnInit } from "@angular/core";
import { StatisticsLine } from "src/models/estate/IResidenceSaleInArea";
import { SearchViewOptionsFilterModel } from "../../../estate-filter/search-filter-view-options/search-filter-view-options.model";
import { PeriodDefinitionType } from "@models/map/market-filter.model";
import { ThousandizePipe } from "ev-core";
import { PercentPipe } from "@angular/common";
import { PluralizerPipe } from "@shared/pipes/pluralizer.pipe";
import { EvRangeIndicatorComponent } from "ev-range-indicator";

@Component({
    selector: "statistics-sold",
    imports: [ThousandizePipe, PercentPipe, PluralizerPipe, EvRangeIndicatorComponent],
    templateUrl: "./statistics-sold.component.html",
    styleUrl: "../market-price-statistics/market-price-statistics.component.scss",
})
export class StatisticsSoldComponent implements OnInit {
    statistics = input.required<StatisticsLine>();
    searchViewOptions = input.required<SearchViewOptionsFilterModel>();
    showDetails = input.required<boolean>();
    isHeader = input.required<boolean>();

    periodType = PeriodDefinitionType;
    soldUnderPercentage: number;
    soldOverPercentage: number;

    ngOnInit() {
        this.calculateSoldPercentages();
    }

    private calculateSoldPercentages() {
        const percentageValue =
            100 / (this.statistics().soldUnderPriceAssumption + this.statistics().soldOnPriceAssumption + this.statistics().soldOverPriceAssumption);
        this.soldUnderPercentage = Math.round(this.statistics().soldUnderPriceAssumption * percentageValue);
        this.soldOverPercentage = Math.round(this.statistics().soldOverPriceAssumption * percentageValue);
    }
}
